import auth from '../../../middleware/auth.js';
import {appHelper} from "../../../utils/helpers/appHelper.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {elementHelper} from "../../../utils/helpers/elementHelper.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";
export const AdminUsers = [
    {
        path: appHelper.path.adminApp + '/authenticate',
        component: routeHelper.asyncComponentWithLoader(() => import('../../../views/layout/NavTab.vue')),
        meta: { middleware: [auth] },
        children: [
            {
                name: 'ubac',
                path: '',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/users/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'abac',
                path: 'abac',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/abac/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'rbac',
                path: 'rbac',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/roles/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'recent-device',
                path: 'recent-device',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/recent-device/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            },
            {
                name: 'device-identity',
                path: 'device-identity',
                component: routeHelper.asyncComponentWithLoader(() => import('../views/device-identity/index.vue')),
                meta: { middleware: [auth, shortcuts] }
            }
        ]
    }
];
